/**
 * @file: 画布cube坐标扫描
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../cubeTree/index';
import * as Toolkit from '../toolkit/index';
import * as StageStatus from '../stageStatus';
import Utils from '../utils/util';
import Store from './store/index';
import Config from '../config/index';
import { add } from './add';
import { sketchpadPhysicsHeight } from './sketchpadPhysicsHeight';

// todo: 卧柜
export function scanAllCubes(): void {
    Config.set({
        moduleName: 'shelf',
        key: 'shelfAreaHeight',
        value: sketchpadPhysicsHeight()
    });

    let shelfs: Array<CubeId> = StageStatus.isTopFace() ? CubeTree.findFreezer() : CubeTree.findShelfs();
    let cubeInStage: Array<CubeId> = CubeTree.findCubeInStage();
    let timeStart: number = new Date().getTime();

    shelfs.forEach((shelfId: CubeId): void => {
        deepScan(shelfId);
    });

    // 画布中可能存在层板，且层板中有可能放置的有组件，所以这里也需要深度递归
    cubeInStage.forEach((cubeId: CubeId): void => {
        deepScan(cubeId);
    });

    let timeEnd: number = new Date().getTime();

    Toolkit.log({
        action: '坐标系统',
        msgList: [
            {
                name: '坐标更新耗时:',
                value: `${timeEnd - timeStart}ms`
            }
        ]
    });
}

// 递归扫描
export function deepScan(cubeId: CubeId): void {
    add(cubeId);

    let childCubeIds: Array<CubeId> = CubeTree.getChildCubeIds(cubeId);

    childCubeIds.forEach((cubeId: CubeId): void => {
        deepScan(cubeId);
    });
}
